import { render, staticRenderFns } from "./projectB.vue?vue&type=template&id=7a294c28&scoped=true&"
import script from "./projectB.vue?vue&type=script&lang=js&"
export * from "./projectB.vue?vue&type=script&lang=js&"
import style0 from "./projectB.vue?vue&type=style&index=0&id=7a294c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a294c28",
  null
  
)

export default component.exports